import React from 'react';

const ScrollDown = props => (
  <svg viewBox='0 0 129 129' {...props}>
    <title>{'Scroll Down'}</title>
    <path d='M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.91.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z' />
  </svg>
);

export default ScrollDown;
